import React from 'react'

export default function CalendarUser() {
    return (
        <div className="container">
            <div className="row">
            <h4 className="newsTitle" style={{marginLeft:"10%"}}><span>Due Date Calendar :-</span></h4>
            <br />
            <iframe src="https://calendar.google.com/calendar/embed?height=600&amp;wkst=1&amp;bgcolor=%23ffffff&amp;ctz=Asia%2FKolkata&amp;src=aW5mb21pbmV3ZWIyMDIwQGdtYWlsLmNvbQ&amp;src=Ym9ucnRzMzZlM2F2ZzJtOHJuY2g4aGk0ZWNAZ3JvdXAuY2FsZW5kYXIuZ29vZ2xlLmNvbQ&amp;color=%23039BE5&amp;color=%23616161&amp;showTitle=0&amp;showTz=0&amp;showPrint=0&amp;showDate=0&amp;showCalendars=0" style="border:solid 1px #777" width="800" height="600" frameborder="0" scrolling="no" style={{width:"80%",height:"500px",marginLeft:"10%"}}></iframe>
        <br></br>
        </div>
        
        </div>
    )
}
